import * as Yup from "yup";

const validationSchema = Yup.object({
  type: Yup.object().required("Type is required."),
  categoryType: Yup.object().required("Category Type is required."),
  name: Yup.string().required("Name is required."),
  code: Yup.string().required("Party Code is required."),
  gstNumber: Yup.string(),
  mobileNumber: Yup.string().min(10, "Invalid mobile number.").max(10, "Invalid mobile number."),
  state: Yup.object().required("State is required."),
  city: Yup.object().required("City is required."),
  address: Yup.string().required("Address is required."),
  transporter: Yup.object().required("Transporter is required."),
});

export { validationSchema };
